import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { EmployeeActivityLog } from '~/scenes/PeopleModule/components/EmployeeActions/EmployeeActivityLogDialog/components/EmployeeActivityLog';

export type EmployeeActivityLogDialogProps = {
  employeeId: number;
  open: boolean;
  onClose: () => void;
};
export const EmployeeActivityLogDialog = ({
  open,
  onClose,
  employeeId,
}: EmployeeActivityLogDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth={'xl'}
      PaperProps={{
        style: {
          minHeight: '90%',
          maxHeight: '90%',
        },
      }}
    >
      <SolaForceDialogTitle onClose={onClose}>
        {t('userActivityLog')}
      </SolaForceDialogTitle>
      <DialogContent dividers={true} sx={{ display: 'grid', padding: 0 }}>
        <EmployeeActivityLog employeeId={employeeId} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
